import axios from 'axios';
import store from '../store'

class PartnerRepository {

    get basePath() {
        return store.state.backend;
    }

    async redirectToLogin() {
        // import dinámico evita ciclo en evaluation-time
        const { default: router } = await import('../router');
        store.commit('clearData');
        router.push('/');
    }

    verifyProUpgradeByPartner(partnerId) {
        const headers = { Authorization: store.state.token };
        return axios
            .get(`${this.basePath}/ext/partners/pro-upgrade/${partnerId}`, { headers })
            .catch(async (error) => {
                if (error?.response?.status === 401) await this.redirectToLogin();
                return Promise.reject(error);
            });
    }
    getBrokersByPartner(partnerId) {
        const headers = { Authorization: store.state.token };
        return axios
            .get(`${this.basePath}/ext/partners/brokers/${partnerId}`, { headers })
            .catch(async (error) => {
                if (error?.response?.status === 401) await this.redirectToLogin();
                return Promise.reject(error);
            });
    }
}

export default new PartnerRepository();